import { render } from "./ContractDetail.vue?vue&type=template&id=70d31124"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"

import "./ContractDetail.vue?vue&type=style&index=0&id=70d31124&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__